import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { notification, message } from 'antd';
import API from '@/services';
import { getDataType } from '@/shared/functions';
import { dispatch } from '@@/store';
import MappingData from '@/shared/mapping';
const statusList = {
    30: '竞拍暂停中,请稍后再试',
    8: '应价中，请稍后再试',
    80: '应价暂停中，请稍后再试',
    50: '待成交',
    51: '应价待成交',
    1: '预展中，请稍后再试',
    2: '待开拍，请稍后再试',
    3: '竞拍中',
    4: '本车拍卖已结束，请等待竞拍结果',
    5: '成交',
    6: '流拍',
    7: '下架',
    999: '场次竞拍已结束',
    777: '场次已撤销',
};
// desc 场次信息
const auction = {
    // desc 场次id
    roundId: null,
    // desc 场次状态 (0 待发拍、1 预展中、2 竞价中、3 已结束)
    roundStatus: null,
    // desc 当前竞拍的竞拍单id
    auctionId: null,
    // desc 上一辆车竞拍单id
    preAuctionId: null,
    // desc 拍卖模式（正式竞拍 true 、模拟竞拍 false ）
    roundSimulateStatus: true,
};
// desc 正在拍卖的车辆信息
const carMsg = {
    // desc 车辆编号
    auctionSerialNumber: '',
    // desc 车辆标题
    carName: '',
    // desc 车辆检测报告
    carRank: '',
    // desc 检测报告类型
    reportResultType: null,
    // desc 车辆图片
    firstImage: '',
    // desc 车辆的竞拍状态
    status: 0,
    // desc 是否为场次中最后一辆车
    theLastCar: false,
    // desc 最高价
    priorityOfferW: '',
    // desc 合手价
    finalOfferW: '',
    // desc 买方佣金
    brokerageW: '',
    // desc 服务费
    commissionW: '',
    // desc 起拍价
    auctionPriceW: '',
};
// desc 拍卖中信息
const auctionMsg = {
    // desc 倒计时秒数
    countNum: 0,
    // desc 展示倒计时时 是否开启倒计时
    countDownStatus: 0,
    // desc 拍卖师是否开启询价
    canResponsePrice: false,
    // desc 询价AuctionId
    responseId: '',
    // desc 询价金额
    responsePrice: null,
    // desc 应价弹窗是否展示
    showResponsePrice: false,
    // desc 是否有人出过价
    hasBid: false,
};
// desc 拍卖结果
const resultData = {
    // 是否展示结果
    isShow: false,
    // 是否已结束（后端）
    hasEnd: 0,
    // 是否已做操作
    hasOperate: false,
    // desc 出价类型
    bidType: null,
    // desc 最高价出价人电话
    phone: null,
    // desc 最高价出价人编码
    buyerCode: null,
    // desc 最高价出价人号牌
    numberPlat: null,
    // desc 结果竞拍ID
    resultAuctionId: null,
    resultAuctionNum: '',
    resultAuctionTitle: '',
    // desc 结果状态
    resultType: 0,
    // desc 结果最高价
    resultPriorityOffer: null,
    resultPriorityOfferW: null,
    resultPriorityOfferY: null,
    // desc 待应价 价格
    resultResponseY: '',
    resultResponseW: '',
    resultResponse: '',
};
// desc 号牌信息
const numberPlatState = {
    // desc 是否为合法号牌
    legalCode: null,
    // desc 用户合法号牌
    buyerLegalCode: '',
};
export default createStore({
    state: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ resetForm: false }, auction), carMsg), auctionMsg), resultData), numberPlatState), { 
        // desc 页面加价结构
        visibleAddCodeNum: false, hasRandomInput: false, addBtnList: [], addBtnListActive: [] }),
    effects: {
        // Fn 获取加价按钮
        getAddBtn(params, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const paramsData = {
                    roundId: state.roundId,
                };
                API.auction.getCustomPriceButton(paramsData)
                    .then((data) => {
                    if (getDataType(data) === 'Array') {
                        if (data.length <= 0) {
                            notification.warn({
                                message: '未获取到任何加价操作',
                            });
                            return;
                        }
                        const hasRandomInput = data.includes(-1) || data.includes('-1');
                        const btnList = data.filter((item) => Number(item) !== -1).map((item) => {
                            return {
                                val: item,
                                state: false,
                            };
                        });
                        this.SET_STATE({
                            addBtnList: btnList,
                            addBtnListActive: btnList,
                            hasRandomInput,
                        });
                    }
                    else {
                        notification.warn({
                            message: '未获取到任何加价操作',
                        });
                    }
                })
                    .catch(() => {
                    notification.warn({
                        message: '未获取到任何加价操作',
                    });
                });
            });
        },
        // Fn 建立长连接
        createConnect(isCreate) {
            return __awaiter(this, void 0, void 0, function* () {
                isCreate ? dispatch.longLinkListen.listen({}) : dispatch.longLinkListen.disconnect({});
            });
        },
        // Fn 处理长链接数据
        dealListen({ type, data }, { state }) {
            const res = JSON.parse(data);
            if (res.roundId === state.roundId) {
                switch (type) {
                    case 'upCar':
                        console.log('上车', res);
                        this.dealResponseData({ res });
                        break;
                    case 'roundStatus':
                        const { roundStatus } = res;
                        roundStatus === 3 && this.auctionEnd(999);
                        roundStatus === 4 && this.auctionEnd(777);
                        console.log('结束', res);
                        break;
                }
            }
            if (res.auctionId === state.auctionId) {
                switch (type) {
                    case 'price': // 价格推送
                        this.dealPriceData(res);
                        this.SET_STATE({
                            hasBid: true,
                        });
                        break;
                    case 'carResult': // 结果
                        this.showResponsePrice(false);
                        this.SET_STATE({
                            responsePrice: null,
                        });
                        this.dealAuctionReslut(res);
                        break;
                    case 'countDownStart': // 开启倒计时推送
                        // FixMe 开启倒计时推送 【竞拍ID：auctionId,countNum:回秒时长】
                        const { status, countDownStatus, countNum } = state;
                        const isShow = status === 3 && countDownStatus === 0 && countNum === 0;
                        if (!isShow) {
                            const { auctionId, countNum } = res;
                            if (state.auctionId === auctionId) {
                                this.countTime({
                                    auctionId,
                                    countNum,
                                });
                            }
                        }
                        break;
                    case 'countDownSuspended': // 暂停
                        this.showResponsePrice(false);
                        this.dealCountTime(res);
                        break;
                    case 'countDownRestore': // 暂停恢复
                        this.dealCountDownRestore(res);
                        break;
                    case 'biddingPrice': // 应价
                        this.beginResponst(res);
                        break;
                    case 'auctionStatus': // 立即结束拍卖推送
                        this.SET_STATE({
                            status: 4,
                        });
                        break;
                }
            }
        },
        // Fn 获取拍卖的拍品数据（http获取详情）
        getDetail({ params, callback }, { state }) {
            const { roundId } = state;
            API.auction.getAuctionInfo({
                roundId,
            })
                .then((res) => {
                this.dealResponseData({ res, callback });
            });
        },
        // Fn 处理http及推送数据
        dealResponseData({ res, callback }, { state }) {
            if (res.auctionId === state.auctionId) {
                return;
            }
            if (res.roundStatus === 0) { // 场次待开拍
                notification.warn({
                    message: '找不到场次信息！',
                });
                return;
            }
            const { carInfo = {}, auctionInfo = {} } = res;
            let resetData = {};
            if (res.auctionId !== state.auctionId) {
                resetData = Object.assign({ resetForm: true }, numberPlatState);
            }
            const usefulData = {
                // desc 场次状态
                roundStatus: res.roundStatus,
                // desc 竞拍Id
                auctionId: auctionInfo.auctionId || res.auctionId,
                // desc 上一辆车竞拍Id
                preAuctionId: auctionInfo.previousAuctionId || res.previousAuctionId,
                // desc 车辆编号
                auctionSerialNumber: carInfo.auctionSerialNumber,
                // desc 车辆标题
                carName: carInfo.carName,
                // desc 车辆检测报告号
                carRank: carInfo.rank || '',
                // desc 车辆检测报告类型
                reportResultType: carInfo.reportResultType === undefined ? null : carInfo.reportResultType,
                // desc 车辆图片
                firstImage: carInfo.firstImage,
                // desc 拍卖模式（正式竞拍 0 、模拟竞拍 1 ）
                roundSimulateStatus: auctionInfo.roundSimulateStatus ? auctionInfo.roundSimulateStatus === 0 : true,
                // desc 拍品状态 车辆的竞拍状态
                status: auctionInfo.status,
                // desc 倒计时秒数
                countNum: auctionInfo.countNum,
                // desc 最高价
                priorityOfferW: auctionInfo.priorityOfferW || auctionInfo.auctionPriceW,
                priorityOfferY: auctionInfo.priorityOfferY || auctionInfo.auctionPriceY,
                // desc 合手价
                finalOfferW: auctionInfo.finalOfferW,
                // desc 买方佣金
                brokerageW: auctionInfo.brokerageW,
                // desc 服务费
                commissionW: auctionInfo.commissionW,
                // desc 是否有人出过价
                hasBid: auctionInfo.bidStatus,
                // desc 起拍价
                auctionPriceW: auctionInfo.auctionPriceW,
                auctionPriceY: auctionInfo.auctionPriceY,
            };
            this.SET_STATE(Object.assign(Object.assign(Object.assign({}, resetData), usefulData), { canResponsePrice: auctionInfo.status === 8 || false }));
            this.getPreAuctionResult({}); // desc 获取上辆车拍卖结果
            this.dealCountTime(res.auctionInfo); // desc 处理倒计时时间
            res.roundStatus === 3 && this.auctionEnd(999); // desc 场次已结束
            res.roundStatus === 4 && this.auctionEnd(777); // desc 场次已撤销
            this.canAuction({});
            callback && callback(state);
        },
        // Fn 是否可操作（(待发拍、预展中、已结束：不可操作，并相应提示。竞价中：可操作）
        canAuction(params, { state }) {
            const { roundStatus } = state;
            // (0 待发拍、1 预展中、2 竞价中、3 已结束)
            let canOperate = null;
            switch (roundStatus) {
                case 0:
                    canOperate = '场次还未发拍，请确认场次状态后再进行操作';
                    break;
                case 1:
                    canOperate = '场次预展中，请确认场次开拍后后再进行操作';
                    break;
                case 2:
                    canOperate = true;
                    break;
                case 3:
                    canOperate = '场次已结束，请确认场次信息';
                    break;
            }
            this.SET_STATE({
                canOperate,
            });
        },
        // Fn 获取上一辆车的竞拍结果
        getPreAuctionResult(params, { state }) {
            const { auctionId, preAuctionId, roundSimulateStatus, roundId, } = state;
            roundSimulateStatus && preAuctionId !== '0' && API.auction.getAuctionResult({
                roundId,
                auctionId,
            }).then((res) => {
                let status = res.status;
                // desc 待成交且询过价
                status === 50 && res.hasQuery && (status = 51);
                // desc 已成交
                this.SET_STATE({
                    isShow: res.auctionId !== 'null' ? true : false,
                    hasEnd: res.hasEnded,
                    // 是否已做操作
                    hasOperate: status === 5 ? 0 : res.hasEnded,
                    // desc 出价类型
                    bidType: res.lineType === undefined ? '' : res.lineType,
                    // desc 最高价出价人电话
                    phone: res.buyerPhone || '',
                    // desc 最高价出价人号牌
                    numberPlat: res.signNumber || '',
                    // desc 结果竞拍ID
                    resultAuctionId: res.auctionId || '',
                    resultAuctionNum: res.auctionSerialNumber || '',
                    resultAuctionTitle: res.carName || '',
                    // desc 结果状态
                    resultType: status === undefined ? '' : status,
                    // desc 结果最高价
                    resultPriorityOfferY: res.priorityOffer || '',
                    resultPriorityOfferW: res.priorityOfferW || '',
                    // desc 待应价 价格
                    resultResponseY: res.priorityOffer || '',
                    resultResponseW: res.priorityOfferW || '',
                });
            });
        },
        // Fn 获取上一辆车的竞拍结果
        cancelPreAuctionResult(params, { state }) {
            const { auctionId, roundId, hasEnd, } = state;
            hasEnd === 0 ? API.auction.cancelPerAuctionResult({
                roundId,
                auctionId,
            }).then((res) => {
                this.getPreAuctionResult({});
                this.CLOSE_RESULT();
            }) : this.CLOSE_RESULT();
        },
        // Fn 操作上一辆竞拍车辆信息
        lastAuctionOperate(params, { state }) {
            const { resultType } = state;
            const callback = () => {
                this.SET_STATE({
                    hasOperate: true,
                });
                this.getPreAuctionResult({});
            };
            switch (resultType) {
                case 51:
                    this.fillResponsePrice({ params, callback });
                    break;
                case 50:
                case 6:
                    this.fillBidPrice({ params, callback });
                    break;
                case 5:
                    this.fillCode({ params, callback });
                    break;
            }
        },
        // Fn 倒计时推送 开启倒计时
        countTime({ auctionId, countNum }, { state }) {
            // 普通出价倒计时 - 轮询是否有人出价 有则回表继续轮询
            this.SET_STATE({
                countDownStatus: 1,
                countNum,
            });
        },
        // Fn 处理倒计时时间
        dealCountTime(auctionInfo, { state }) {
            if (!auctionInfo) {
                return;
            }
            const countData = {
                countDownStatus: state.countDownStatus,
            };
            const status = Number(auctionInfo.status);
            if (!status) {
                return;
            }
            if (state.countNum === 0 || auctionInfo.type === 1) {
                this.SET_STATE({
                    status,
                });
                return;
            }
            if (status === 30 || status === 80) { // 竞拍暂停 || 应价暂停
                countData.countDownStatus = 2; // 暂停
                auctionInfo.countNum && (countData.countNum = auctionInfo.countNum); // 秒数
                this.loop({});
            }
            else if (status === 3 && auctionInfo.countDownStatus === 1) { // 竞拍中 && 倒计时开启
                countData.countDownStatus = 1; // 开启
                auctionInfo.countNum && (countData.countNum = auctionInfo.countNum); // 秒数
            }
            else if (status === 3 && !auctionInfo.countDownStatus) {
                countData.countDownStatus = 0;
                auctionInfo.countNum && (countData.countNum = auctionInfo.countNum); // 秒数
            }
            if (auctionInfo.type === 3) {
                countData.canResponsePrice = false;
            }
            this.SET_STATE(Object.assign(Object.assign({}, countData), { status }));
        },
        // Fn 处理价格推送
        dealPriceData(res, { state }) {
            const status = res.status || state.status;
            let countData = {};
            switch (status) {
                case 3:
                    countData = {
                        // desc 倒计时秒数
                        countNum: res.countNum,
                        // desc 是否开启倒计时
                        countDownStatus: res.countDownStatus,
                    };
                    break;
                case 30:
                    countData = {
                        // desc 是否开启倒计时
                        countDownStatus: 2,
                    };
                    break;
            }
            const usefulData = Object.assign(Object.assign({}, countData), { 
                // desc 竞拍Id
                auctionId: res.auctionId, 
                // desc 最高价
                priorityOfferW: res.priorityOfferW, priorityOfferY: res.priorityOfferY, 
                // desc 合手价
                finalOfferW: res.finalOfferW, 
                // desc 买方佣金
                brokerageW: res.brokerageW, 
                // desc 服务费
                commissionW: res.commissionW, 
                // desc 是否开启倒计时
                countDownStatus: res.countDownStatus });
            this.SET_STATE(Object.assign({}, usefulData));
        },
        // Fn 场次结束提示
        auctionEnd(auctionState, { state }) {
            this.SET_STATE({
                status: auctionState,
                // desc 倒计时秒数
                countNum: auctionMsg.countNum,
                // desc 展示倒计时时 是否开启倒计时
                countDownStatus: auctionMsg.countDownStatus,
            });
            notification.warn({
                key: 'end',
                message: statusList[auctionState],
            });
        },
        // Fn 开启应价
        beginResponst(res, { state }) {
            this.SET_STATE({
                canResponsePrice: true,
                responsePrice: res.priorityOfferY,
                responseId: res.auctionId,
                countNum: res.countNum,
                countDownStatus: 1,
                priorityOfferW: res.priorityOfferW,
            });
            const updatePrice = {};
            res.finalOfferW && (updatePrice.finalOfferW = res.finalOfferW);
            res.brokerageW && (updatePrice.brokerageW = res.brokerageW);
            res.commissionW && (updatePrice.commissionW = res.commissionW);
            this.SET_STATE(Object.assign({}, updatePrice));
        },
        // Fn 轮询
        loop(params, { state }) {
            setTimeout(() => {
                API.auction.getAuctionInfo({
                    roundId: state.roundId,
                }).then((res) => {
                    if (res.roundStatus === 3) {
                        this.SET_STATE({
                            status: 999,
                        });
                        return false;
                    }
                    this.dealCountTime(res.auctionInfo);
                });
            }, 1000);
        },
        // Fn 处理暂停恢复推送
        dealCountDownRestore(res, { state }) {
            switch (res.type) {
                case 3: // 暂停应价
                    this.SET_STATE({
                        status: res.status,
                        canResponsePrice: true,
                        countNum: res.countNum,
                        countDownStatus: 1,
                    });
                    break;
                case 1: // 暂停拍卖
                    this.SET_STATE({
                        countDownStatus: 0,
                        countNum: 0,
                        status: res.status,
                    });
                    break;
                case 2: // 暂停结束倒计时
                    this.SET_STATE({
                        status: res.status,
                        countDownStatus: 1,
                        countNum: res.countNum,
                    });
                    break;
            }
        },
        // Fn 拍卖师询价，加价师点击应价按钮锁定
        lockResponsePrice({ isLock, callback }, { state }) {
            API.auction.biddingOperation({
                auctionId: state.responseId || state.auctionId,
                biddingType: isLock ? 0 : 1,
            }).then(() => {
                this.showResponsePrice(isLock);
                callback && callback(isLock);
            });
        },
        // Fn 拍卖师询价，加价师应价
        responsePrice({ userCode, callback }, { state }) {
            this.bid({
                bidType: 2,
                roundId: state.roundId,
                auctionId: state.auctionId,
                price: state.responsePrice,
                flapper: userCode,
                callback: (state) => {
                    this.showResponsePrice(false);
                    state && this.SET_STATE({
                        countDownStatus: auctionMsg.countDownStatus,
                        countNum: auctionMsg.countNum,
                    });
                    callback && callback();
                },
            });
        },
        // Fn 应价待成交后补应价
        fillResponsePrice({ params, callback }, { state }) {
            API.auction.bid({
                bidType: 4,
                roundId: state.roundId,
                auctionId: state.resultAuctionId,
                price: state.resultResponseW,
                highestPrice: state.resultResponseY,
                flapper: params.BuyerCode,
            })
                .then(() => {
                callback();
            });
        },
        // Fn 待成交后补充出价
        fillBidPrice({ params, callback }, { state }) {
            API.auction.bid({
                bidType: 3,
                roundId: state.roundId,
                auctionId: state.resultAuctionId,
                price: params.price,
                highestPrice: state.resultPriorityOfferY,
                flapper: params.BuyerCode,
            })
                .then(() => {
                callback();
            });
        },
        // Fn 加价
        addPrice({ isFixedNum, addPrice, callback }, { state }) {
            const { legalCode, buyerLegalCode } = state;
            if (legalCode === false) {
                notification.error({
                    message: '买家号码牌不存在',
                    description: '请确认填写正确号码牌',
                });
                return;
            }
            // FixMe 加价请求
            this.bid({
                bidType: isFixedNum ? 0 : 1,
                price: addPrice,
                flapper: buyerLegalCode,
                callback,
            });
        },
        // Fn 出价/应价请求
        bid({ bidType, price, flapper, callback, desc = '' }, { state }) {
            API.auction.bid({
                bidType,
                roundId: state.roundId,
                auctionId: state.auctionId,
                price,
                highestPrice: state.priorityOfferY || state.auctionPriceY,
                flapper,
            })
                .then((res) => {
                let tip = '';
                switch (bidType) {
                    case 0: // 出价-固定金额
                    case 3: // 车辆未成交-补充出价
                        tip = '加价';
                        break;
                    case 1: // 出价-自定义金额
                        tip = '出价';
                        break;
                    case 2: // 应价
                        tip = '应价';
                        break;
                }
                if (bidType === 0 || bidType === 1) {
                    this.SET_STATE({
                        hasBid: true,
                    });
                }
                this.SET_STATE({
                    priorityOfferY: res.priorityOfferY,
                    priorityOfferW: res.priorityOfferW,
                    brokerageW: res.brokerageW,
                    commissionW: res.commissionW,
                    finalOfferW: res.finalOfferW,
                    countNum: res.countNum,
                    legalCode: null,
                    buyerLegalCode: '',
                });
                notification.success({
                    message: `${tip}成功`,
                    description: desc,
                });
                callback && callback(true);
            })
                .catch(() => {
                this.getDetail({});
                callback && callback(false);
            });
        },
        // Fn 校验号牌合法性
        checkBuyerCode(code, { state }) {
            this.SET_STATE({
                buyerLegalCode: code,
            });
            API.auction.existFlapper({
                flapper: code,
                roundId: state.roundId,
            })
                .then((state) => {
                const isEsit = getDataType(state) === 'Boolean' ? state : state.data;
                this.SET_STATE({
                    legalCode: Boolean(isEsit),
                });
            });
        },
        // Fn 补号牌请求
        fillCode({ params, callback }, { state }) {
            API.auction.addFlapperInfo({
                roundId: state.roundId,
                auctionId: state.resultAuctionId,
                flapper: params.BuyerCode,
            })
                .then((res) => {
                if (res.fillStatus === 0) {
                    callback && callback();
                }
                message.info(res.msg);
            });
        },
        // Fn 处理结果推送
        dealAuctionReslut(resultType, { state }) {
            this.SET_STATE({
                countDownStatus: 0,
            });
            const statusStr = MappingData.auctionState[resultType.status];
            message.info(`车辆${statusStr}`, resultType.countNum || 1, () => {
                this.getDetail({});
            });
        },
        // Fn 重置结果数据
        resetResult() {
            this.SET_STATE(Object.assign({}, resultData));
        },
        // Fn 重置倒计时
        resetCount() {
            this.SET_STATE({
                countNum: 0,
                countDownStatus: 0,
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        // desc 展示应价弹窗
        showResponsePrice(state, isShow) {
            state.showResponsePrice = isShow;
        },
        // desc 重置号牌
        RESET_CARD(state) {
            state.legalCode = numberPlatState.legalCode;
            state.buyerLegalCode = numberPlatState.buyerLegalCode;
        },
        // desc 重置号牌校验状态
        resetCheckState(state) {
            state.legalCode = null;
            state.buyerLegalCode = '';
        },
        SHOW_RESULT(state) {
            state.isShow = true;
        },
        CLOSE_RESULT(state) {
            state.hasOperate = true;
        },
    },
});
